"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var utils_1 = require("../utils");
function normalizeFetchedSuggestions(_a) {
    var data = _a.data, _b = _a.inputValue, inputValue = _b === void 0 ? '' : _b, _c = _a.searchType, searchType = _c === void 0 ? constants_1.SearchType.TextSearch : _c;
    if (!data)
        return [];
    return data.map(function (_a, index) {
        var text = _a.text, rest = __rest(_a, ["text"]);
        return (__assign(__assign({}, rest), { searchType: searchType, suggestionIndex: index, text: text, highlightedText: (0, utils_1.highlightText)(text, inputValue) }));
    });
}
exports.default = normalizeFetchedSuggestions;
//# sourceMappingURL=normalizeFetchedSuggestions.js.map